import React from 'react';
import { specials } from '../data/specials';
export function SpecialOffers() {
  return <section id="specials" aria-labelledby="specials-heading" className="w-full bg-cream" data-id="element-94" data-mp="1hok1qk6gtzag">
      <div className="mx-auto max-w-6xl px-4 pb-14 sm:px-6" data-id="element-95" data-mp="1cpp8eoavgsc3">
        <div className="flex items-baseline gap-3" data-id="element-96" data-mp="1co5u338s0rcy">
          <h2 id="specials-heading" className="font-display text-3xl text-verde sm:text-4xl" data-id="element-97" data-mp="18p5cfo21burj">
            Especiales
          </h2>
          <span className="text-base font-medium text-muted" data-id="element-98" data-mp="13qvgvccees5e">This week's specials</span>
        </div>
        <ul className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-99" data-mp="ywznyoazrvh3">
          {specials.map(s => <li key={s.id} className="grid grid-rows-[auto_1fr] overflow-hidden rounded-2xl bg-paper ring-1 ring-line" data-id="element-100" data-mp="tzr1wcmq37ak">
              <div className="relative" data-id="element-101" data-mp="kz2mpellf0w3">
                <img src={s.image} alt={s.title} className="aspect-[16/10] w-full object-cover" loading="lazy" data-id="element-102" data-mp="kxzv14gg4uf4" />
                <span className="absolute right-3 top-3 rounded-full bg-salsa px-3 py-1 text-sm font-bold text-white shadow-sm" data-id="element-103" data-mp="17awadejwrtqx">
                  {s.price}
                </span>
              </div>
              <div className="flex flex-col border-t-4 border-verde p-5" data-id="element-104" data-mp="yddlfz358v9r">
                <p className="text-sm font-semibold text-salsa" data-id="element-105" data-mp="12dxmhdqu8j16">{s.when}</p>
                <h3 className="mt-1 font-display text-2xl leading-tight text-ink" data-id="element-106" data-mp="1q2gstnqbulqm">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-107" data-mp="1v2bgzjipwx7z">{s.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}